import { render, staticRenderFns } from "./Newuser.vue?vue&type=template&id=4bd74d8f"
import script from "./Newuser.vue?vue&type=script&lang=js"
export * from "./Newuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports